





















import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";

interface BuffInterface {
	icon: string;
	type: string;
}

@Component
export default class Buff extends Vue {
	/// Injections
	imageLinks = imageLinks;

	@Prop()
	quantity!: number;

	@Prop()
	buff!: BuffInterface;
}
